import type { FormError } from 'asap-team/asap-tools';

export const requiredError: FormError = {
  name: 'required',
  text: 'This field is required',
  rules: ['touched', 'dirty'],
};
